import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const callsManagement = createApi({
    reducerPath: "callsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        callsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/calls`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewCall: builder.mutation({
            query: (callId) => ({
                url: `v1/${locale}/calls/${callId}`,
                method: "GET",
            }),
        }),

        addCall: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/calls`,
                method: "POST",
                body: body,
            }),
        }),

        updateCall: builder.mutation({
            query: ({ body, callId }) => ({
                url: `v1/${locale}/calls/${callId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteCall: builder.mutation({
            query: (callId) => ({
                url: `v1/${locale}/calls/${callId}`,
                method: "DELETE",
            }),
        }),

        exportCalls: builder.mutation({
            query: () => ({
                url: `v1/${locale}/export/calls`,
                method: "GET",
                responseHandler: (response) => response.blob(),
            }),
        }),

        callsListByStudent: builder.mutation({
            query: (studentId) => ({
                url: `v1/${locale}/calls/student/${studentId}`,
                method: "GET",
            }),
        }),
    }),
});

export const { 
    useAddCallMutation,
    useCallsListMutation,
    useDeleteCallMutation,
    useUpdateCallMutation,
    useViewCallMutation,
    useExportCallsMutation,
    useCallsListByStudentMutation
} = callsManagement;
